import $ from "jquery";
import "select2";
import "select2/src/scss/core.scss";

class CustomSelect {
    constructor(className, searchBox) {
        this.selectReal = document.querySelector("." + className);
        this.init(className, searchBox);
        this.events(className);
    }

    events(className) {
        $("." + className).on("select2:select", (e) => {
            this.selectReal.value = e.params.data.id;
        });
    }

    init(className, searchBox) {
        $("." + className).select2({
            width: "100%",

        });
        if (!searchBox) {
            this.hideSearchbox(className);
        }
    }

    hideSearchbox(className) {
        $("." + className).select2({
            minimumResultsForSearch: Infinity,
            dropdownCssClass: className+'__custom-font-js',
        });
    }
}

export default CustomSelect;
